export default __webpack_public_path__ + "alberta-derive-incontinence.ef44939d8689780575da.svg";